import {
  FETCH_LIST_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_REQUEST,
  FETCH_LIST_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_SUCCESS,
  FETCH_LIST_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_FALUIRE,
} from './loadProjectTemplateTaskGroupByIDTypes'

const initialState = {
  loading: false,
  projectTemplateTaskGroupInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LIST_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LIST_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_SUCCESS : return {
      ...state,
      projectTemplateTaskGroupInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LIST_PROJECT_TEMPLATE_TASK_GROUP_BY_ID_FALUIRE : return {
      ...state,
      loading: false,
      projectTemplateTaskGroupInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
